export default __webpack_public_path__ + "static/media/7-sgi-matricula-v1.png:Zone.0543b9e3.Identifier";